import React, { useEffect, useState } from "react";
import cn from "classnames";
import { Order } from "../../../../../services";
import style from "./InsuranceStatus.module.scss";
import ShieldCheckIcon from "../../../../shared/icons/ShieldCheckIcon";
import ErrorIcon from "../../../../shared/icons/ErrorIcon";
import ClockIcon2 from "../../../../shared/icons/ClockIcon2";
import DownloadIcon from "../../../../shared/icons/DownloadIcon";
import { useTranslation } from "react-i18next";

const InsuranceStatus = ({ orderId }) => {
  const { t } = useTranslation();
  const [insurance, setInsurance] = useState(null);

  useEffect(() => {
    if (!orderId) return;
    Order.getSabrInsuranceStatus(orderId, "client")
      .then((res) => setInsurance(res.data))
      .catch((err) => console.log(err));
  }, [orderId]);

  if (!insurance) return null;

  const { status, paymentUrl, policyUrl } = insurance;

  const handleDownloadPolicy = () => {
    if (!policyUrl) return;
    window.open(policyUrl, "_blank", "noopener,noreferrer");
  };

  if (status === "Active") {
    return (
      <div className={cn(style.wrapper)}>
        <div className={style.left}>
          <div className={style.icon}>
            <ShieldCheckIcon />
          </div>
          <p className={style.title}>{t("insuranceStatus.cargoInsured")}</p>
        </div>
        {policyUrl && (
          <button
            type="button"
            className={style.downloadBtn}
            onClick={handleDownloadPolicy}
          >
            <DownloadIcon />
            <span>{t("insuranceStatus.downloadPolicy")}</span>
          </button>
        )}
      </div>
    );
  }

  if (status === "Cancelled") {
    return (
      <div className={style.wrapper}>
        <div className={style.left}>
          <div className={style.icon}>
            <ErrorIcon />
          </div>
          <p className={style.text}>
            {t("insuranceStatus.cancelledMessage")}
          </p>
        </div>
        <span className={cn(style.badge, style.badge_cancelled)}>{t("insuranceStatus.statusCancelled")}</span>
      </div>
    );
  }

  if (status === "Pending") {
    return (
      <div className={style.wrapper}>
        <div className={style.left}>
          <div className={style.icon}>
            <ClockIcon2 />
          </div>
          <p className={style.text}>
            {t("insuranceStatus.pendingMessage")}
          </p>
        </div>
        <a
          href={paymentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(style.finishBtn, { [style.finishBtn_disabled]: !paymentUrl })}
        >
          {t("insuranceStatus.finishRegistration")}
        </a>
      </div>
    );
  }

  // 🧪 Для тестирования — fallback для неизвестных статусов. Удалить, когда дизайн проверен.
  if (status) {
    return (
      <div className={style.debug_block}>
        <span className={style.debug_label}>{t("insuranceStatus.debugTitle")}</span>
        <span className={style.debug_label}>{t("insuranceStatus.debugTesting")}</span>
        <div className={style.debug_row}>
          <span className={style.debug_key}>status:</span>
          <span className={style.debug_value}>{status}</span>
        </div>
        <div className={style.debug_row}>
          <span className={style.debug_key}>paymentUrl:</span>
          {paymentUrl ? (
            <a href={paymentUrl} target="_blank" rel="noopener noreferrer" className={style.debug_url}>
              {paymentUrl}
            </a>
          ) : (
            <span className={style.debug_empty}>{t("insuranceStatus.emptyValue")}</span>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default InsuranceStatus;
